import TeamSettingsPage from './Settings/TeamSettingsPage';
import CreateTeam from './CreateTeam';
import TeamEdit from "./TeamEdit";

export default {
  list: TeamSettingsPage,
  create: CreateTeam,
  edit: TeamEdit
}
